import * as React from 'react';

import { useQuery } from '@apollo/client';
import ProjectByIdQuery from '@graphql/queries/ProjectByIdQuery';
import { KeyboardBackspace as KeyboardBackspaceIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RouterProps } from 'react-router';

import PairedComparisonPreferenceComponent from './PairedComparisonPreferenceComponent';
import LoadingScreen from '../../../components/LoadingScreen';
import selectWorkspaceProducerId from '../../../selectors/workspaceProducerId';
import { PageHeader, PagePaper } from '../../../styles/themeComponents';
import { checkIsWrongWorkspace } from '../../../utils/afsUtils';

interface Props extends RouterProps {
  match: Record<string, any>;
}

const ReportPairedComparisonPreference: React.FC<Props> = (props) => {
  const { match, history } = props;
  const { projectId: projectIdParam, reportId }: { projectId: string; reportId: string } =
    match.params;
  const projectId: number | undefined = isNaN(parseInt(projectIdParam))
    ? undefined
    : parseInt(projectIdParam);

  const { t } = useTranslation();

  const workspaceId = useSelector((state) => selectWorkspaceProducerId(state));

  const { data: projectCheck, loading: projectCheckLoading } = useQuery<reports.ProjectByIdResponse>(ProjectByIdQuery, {
    variables: { projectId },
    skip: projectId === undefined,
  });

  const isWrongWorkspace = checkIsWrongWorkspace(projectId, projectCheck, workspaceId, reportId);

  if (projectCheckLoading) {
    return <LoadingScreen />;
  }

  if (isWrongWorkspace) {
    return (
      <div>
        <h2>{t('errors.accessForbidden', 'Access Forbidden')}</h2>
        <p>
          {t(
            'errors.noProjectAccess',
            'You do not have access to view this project. Please ensure you are in the correct workspace.',
          )}
        </p>
      </div>
    );
  }

  return (
    <PagePaper>
      <IconButton
        onClick={history.goBack}
        size="small"
        style={{ marginLeft: -26 }}
      >
        <KeyboardBackspaceIcon fontSize="small" />
        <PageHeader>{t('projects.projectFlavorSummary.back')}</PageHeader>
      </IconButton>
      <PairedComparisonPreferenceComponent
        reportId={reportId}
        projectId={projectId}
      />
    </PagePaper>
  );
};

export default ReportPairedComparisonPreference;
